import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IPlannerYellowBorderState {
    showYellowBorder: boolean;
}

const initialState: IPlannerYellowBorderState = {
    showYellowBorder: false,
};

const plannerYellowBorderSlice = createSlice({
    name: "plannerYellowBorderStore",
    initialState,
    reducers: {
        setShowYellowBorder(state: IPlannerYellowBorderState, action: PayloadAction<boolean>) {
            state.showYellowBorder = action.payload;
        },
    },
});

export const { setShowYellowBorder } = plannerYellowBorderSlice.actions;

export default plannerYellowBorderSlice.reducer;
